import { t as shopify_cart_default } from "./shopify-cart-ChiJJ022.js";
//#region src/scripts/extenders/cart-options.js
var CartOptions = class extends HTMLElement {
	constructor() {
		super();
		this.querySelectorAll(".js-add-delivery").forEach((button) => {
			button.addEventListener("click", () => {
				const quantity = button.closest(".content__variant").querySelector(".input-row__quantity select")?.value;
				console.log(quantity);
				const formData = {
					productVariant: button.id,
					quantity: quantity !== void 0 ? quantity : 1
				};
				shopify_cart_default.add(formData, button);
			});
		});
	}
};
if (customElements.get("cart-options") === void 0) customElements.define("cart-options", CartOptions);
//#endregion
